<template>
  <div
    class="credits-button flex"
    :class="{
      [`credits-button--${createRenderType}`]: true,
    }"
  >
    <div class="credits-button-credits width-0 flex1" @click="goBuyCredits">
      {{ $$t("create.credits_remaining") }}
      {{ renderData.userCredits }}
    </div>

    <div class="credits-button-button">
      <Button
        @click="onButtonClick"
        :disabled="props.disabled"
        :loading="props.loading"
        :renderStyle="{
          '--padding': '0',
          '--width': '100%',
          '--height': '48px',
          '--borderRadius': '48px',
          '--background':
            'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
          '--fontColor': '#000',
          '--fontSize': '16px',
          '--fontWeight': '500',
          '--border': 'none',
          '--backgroundHover':
            'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
          '--fontColorHover': '#000',
        }"
      >
        <span class="fn-inline">{{ props.buttonText }}</span>
      </Button>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import { $$language, $$t } from "@/i18n/i18n.js";

import Button from "@/components/basic/button/Button.vue";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";

const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();

const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  buttonText: {
    type: String,
    default: "",
  },
  membership_source: {
    type: Object,
    default: () => {
      return {
        membership_source1: "editor",
        membership_source2: "credits",
      };
    },
  },
});
const emits = defineEmits(["onClick"]);
const renderData = reactive({
  userCredits: userDataStore.isLogin ? userDataStore.credits ?? 0 : 0,
});

const goBuyCredits = () => {
  Router.push({
    name: "subscribe",
    query: {
      membership_source1: "editor",
      membership_source2: "credits",
      ...props.membership_source,
    },
  });
};

const onButtonClick = () => {
  emits("onClick");
};

watch(
  () => {
    return userDataStore.credits;
  },
  () => {
    renderData.userCredits = userDataStore.credits ?? 0;
  }
);

onMounted(() => {});
</script>
<style lang="scss">
.credits-button {
  height: 48px;
  border-radius: 50px;
  background: rgba(148, 173, 255, 0.2);
  align-items: center;
  .credits-button-credits {
    padding: 0 16px;
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
    &:hover {
      color: #94adff;
    }
  }
  .credits-button-button {
    width: 200px;
  }
  .el-button {
    .el-icon.is-loading {
      background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
    }
  }

  &.credits-button--mobile {
    .credits-button-credits {
      display: block;
      font-size: 14px;
      line-height: 18px;
    }
    .credits-button-button {
      width: 160px;
    }
  }
}
</style>
